import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import Typewriter from '../../components/action/Typewriter';
import ThemeLogo from '../../components/theme/ThemeLogo';
import ThemedText from '../../components/theme/ThemedText';
import './Steps.scss';

const Step0 = ({ onNext }) => {
  const fadeInStyles = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
  });

  const logoDelay = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 500 },
    delay: 2000,
  });

  const Text = `Oi mate!`;
  return (
    <animated.div style={fadeInStyles} className='chat_step_wrapper'>
      <animated.div style={logoDelay} className='logo_height'>
        {' '}
        <ThemeLogo icon={'mercleLogoWhite'} />
      </animated.div>

      <ThemedText.h1>
        <Typewriter text={Text} duration={1000} startDelay={100} />
      </ThemedText.h1>
      <animated.div style={logoDelay} className='continue_button' onClick={onNext}>
        Continue
      </animated.div>
    </animated.div>
  );
};

export default Step0;
